import * as h2Api from '../h2Api'

export const OPEN_MODAL = 'DOCUMENTATION_OPEN_MODAL'
export const CLOSE_MODAL = 'DOCUMENTATION_CLOSE_MODAL'
export const SET_SELECTED_SECTION = 'DOCUMENTATION_SET_SELECTED_SECTION'

export const openCollection = c => dispatch => {
  return dispatch(h2Api.get(`/documentation/collection/${c}`)({ type: OPEN_MODAL }))
}

export const closeDocumentationModal = () => dispatch => {
  return dispatch({ type: CLOSE_MODAL })
}

export const selectSection = sectionId => dispatch => {
  return dispatch({ type: SET_SELECTED_SECTION, selectedSection: sectionId })
}
